export default {
    "login_text1": "登录",
    "login_text2": "董视通",
    "login_text3": "管理控制台",
    "login_text4": "登录",
    "login_text5": "用户名或邮箱",
    "login_text6": "请输入用户名或邮箱",
    "login_text7": "密码",
    "login_text8": "请输入密码",
    "login_text9": "一次性验证码",
    "login_text10": "请输入验证码",
    "login_text11": "发送中...",
    "login_text12": "请于",
    "login_text13": "秒后重试",
    "login_text14": "发送验证码",
    "login_text15": "使用德勤账号登录",
    "login_text16": "激活账号",
    "login_text17": "设置密码",
    "login_text18": "修改密码",
    "login_text19": "旧密码",
    "login_text20": "请输入旧密码",
    "login_text21": "新密码",
    "login_text22": "请输入新密码",
    "login_text23": "确认新密码",
    "login_text24": "'新密码'和'确认新密码'不一致",
    "login_text25": "您的密码已过期，请修改密码后重新登录",
    "login_text26": "您是否要退出登录?",
    "login_text27": "请选择要登录的角色：",
    "login_text28": "必填",
    "login_text29": "请输入旧密码",
    "login_text30": "请输入新密码",
    "login_text31": "请输入确认新密码",
    "login_text32": "登录成功",
    "login_text33": "退出成功",
    "login_text34": "测试环境",
    "login_text35": "忘记密码",
    "login_text36": "获取邮箱验证码后设置新密码。",
    "login_text37": "密码至少10位，需包含大写字母、小写字母、数字和特殊字符；不可包含连续或重复字符，以及常见字典词。",
    "login_text38": "如果账号存在，验证码已发送到注册邮箱。",
    "login_text39": "密码重置成功，请重新登录。",
    "validation_required": "请输入{field}",
    "validation_required_input": "请输入{field}",
    "field_nickName": "昵称",
    "field_userName": "用户名",
    "field_email": "邮箱",
    "field_title": "职务",
    "field_tenure": "任期（年）",
    "field_age": "年龄",
    "field_moduleVersion": "版本",
    "field_moduleName": "模组名称",
    "field_moduleNameEn": "模组英文名称",
    "field_description": "描述",
    "field_descriptionEn": "英文描述",
    "field_type": "类型",
    "field_participantScope": "参与者范围",
    "field_package": "Package",
    "field_paymentStatus": "付款状态",
    "field_questionVersion": "版本",
    "field_questionType": "问题类型",
    "field_questionTitle": "问题标题",
    "field_questionTitleEn": "问题英文标题",
    "field_companyName": "公司名称",
    "field_companyNameEn": "公司英文名称",
    "field_stockCode": "股票代码",
    "field_entityType": "公司类型",
    "field_industry": "行业",
    "field_sector": "细分行业",
    "field_yearEnd": "年结日",
    "field_address": "地址",
    "field_region": "地区",
    "field_spName": "Package名称",
    "field_spNameEn": "Package英文名称",
    "field_profFee": "专业费用",
    "field_orderNum": "排序",
    "field_isDirector": "是否董事",
    "field_isLead": "是否负责人",
    "field_post": "职位",
    "field_role": "角色",
    "field_sex": "性别",
    "field_relevantQuestion": "相关问题",
    "field_owner": "负责人",
    "field_shortObservationName": "简短观察名称",
    "field_observationDetails": "观察详情",
    "field_actionTitle": "行动标题",
    "field_actionDetails": "行动详情",
    "field_targetDate": "目标日期",
    "field_status": "状态",
    "field_launchDate": "开始日期",
    "field_deadlineDate": "截止日期",
    "field_autoReminders": "自动提醒",
    "field_content": "内容",
    "field_password": "密码",
    "footer_text1": "德勤•关黄陈方会计师行（中国香港）、德勤•关黄陈方会计师行（中国澳门）及德勤华永会计师事务所（特殊普通合伙）（中国大陆）版权所有。",
    "footer_text2": "Deloitte（“德勤”）泛指德勤有限公司（一家根据英国法律组成的私人担保有限公司，以下称“德勤有限公司”），以及其一家或多家成员所和它们的关联机构。德勤有限公司与每一个成员所均为具有独立法律地位的法律实体。德勤有限公司（又称“德勤全球”）並不向客户提供服务。请参阅",
    "footer_text3": "关于德勤",
    "footer_text4": "以了解更多有关德勤有限公司及其成员所的详情。",
    "open": "打开",
    "menu1": "项目管理",
    "menu2": "董事会评估",
    "menu3": "首页",
    "menu4": "项目管理",
    "menu5": "服务方案管理",
    "menu6": "模块管理",
    "menu7": "题库管理",
    "menu8": "安全与权限",
    "menu9": "系统管理",
    "menu10": "AI 助手",
    "cancel": "取消",
    "confirm": "确认",
    "submit": "提交",
    "reset": "重置",
    "search": "搜索",
    "save": "保存",
    "index": "索引",
    "actionUp": "操作",
    "confirmationReminder": "提示",
    "true": "是",
    "false": "否",
    "pleaseSelect": "请选择",
    "placeholder_select": "请选择",
    "placeholder_select_version": "请选择版本",
    "placeholder_select_role": "请选择角色",
    "placeholder_search_modules": "搜索模块",
    "placeholder_search_question": "搜索题目",
    "placeholder_search_user": "按姓名、邮箱、机构搜索",
    "placeholder_select_deadline": "选择截止日期",
    "placeholder_type_answer": "请输入您的回答",
    "placeholder_gap_ref": "例如：GAP-H18-01",
    "operation-successfully": "操作成功",
    "operationFail": "操作失败",
    "complete": "已完成",
    "inProgress": "进行中",
    "notStarted": "未开始",
    "reviewing": "评审中",
    "generateReport": "生成报告",
    "tobeReport": "待生成报告",
    "yes": "是",
    "no": "否",
    "refreshCache": "刷新缓存",
    "dataDictionary": "数据字典",
    "privacyContentTitle": "隐私声明内容",
    "privacyContentVersion": "版本",
    "privacyContentLastUpdated": "最后更新",
    "privacyContentEdit": "编辑",
    "privacyContentEditDialogTitle": "编辑隐私声明内容",
    "privacyContentVersionPlaceholder": "例如 v1.0",
    "privacyContentVersionTip": "更改版本后，所有客户管理员和参与者用户都需要重新阅读及接受隐私声明。",
    "privacyContentEnglish": "英文",
    "privacyContentChinese": "中文",
    "privacyContentTitleEn": "标题（英文）",
    "privacyContentTitleCn": "标题（中文）",
    "privacyContentContentEn": "内容（英文）",
    "privacyContentContentCn": "内容（中文）",
    "privacyContentVersionChangedWarning": "隐私声明版本已更改，所有客户管理员和参与者用户都需要重新接受。",
    "field_privacyVersion": "版本",
    "field_privacyTitleEn": "英文标题",
    "field_privacyTitleCn": "中文标题",
    "field_privacyContentEn": "英文内容",
    "field_privacyContentCn": "中文内容",
    "privacyConsentDialogTitle": "隐私声明与同意",
    "privacyConsentReadCheckbox": "我确认已阅读隐私声明。",
    "privacyConsentPersonalInfoCheckbox": "本人同意收集、使用及处理本人个人资料作董视通服务用途。",
    "privacyConsentLogoutPrompt": "您必须确认以上两项隐私声明后才能进入系统。是否现在退出登录？",
    "privacyConsentDefaultTitle": "隐私声明",
    "notFoundText1": "404 - 找不到页面",
    "notFoundText2": "您访问的页面不存在",
    "notFoundText3": "返回首页",
    "errorCodeText1": "身份验证失败，无法访问系统",
    "errorCodeText2": "您无当前操作权限",
    "errorCodeText3": "访问的资源不存在",
    "errorCodeText4": "系统未知错误，请向管理员报告",
    "system_text1": "请求的数据大小超过允许的5M限制，无法进行防重复提交验证。",
    "system_text2": "数据处理中，请不要重复提交",
    "system_text3": "您的登录状态已过期。您可以选择停留在此页面或重新登录。",
    "system_text4": "重新登录",
    "system_text5": "取消",
    "system_text6": "会话无效或已过期，请重新登录。",
    "system_text7": "后端接口连接异常",
    "system_text8": "系统接口请求超时",
    "system_text9": "系统接口",
    "system_text10": "异常",
    "system_text11": "系统提示",
    "system_text12": "加载中...",
    "header_text1": "董视通",
    "header_text2": "精准洞察，智慧治理",
    "header_text3": "修改密码",
    "header_text4": "旧密码",
    "header_text5": "新密码",
    "header_text6": "公司",
    "header_text7": "切换公司",
    "page1-text1": "客户信息",
    "page1-text2": "新增客户",
    "page1-text3": "实体名称",
    "page1-text4": "股票代码",
    "page1-text5": "财政年度结束日",
    "page1-text6": "创建人",
    "page1-text7": "创建时间",
    "page1-text8": "状态",
    "page1-text9": "打开",
    "page2-text1": "项目信息",
    "page2-text2": "新增项目",
    "page2-text4": "编辑项目",
    "page2-text5": "全部",
    "page2-text6": "待审批",
    "page2-text7": "有效",
    "page2-text8": "已过期/已归档",
    "page2-text9": "项目",
    "page2-text10": "客户",
    "page2-text11": "负责人",
    "page2-text12": "服务方案",
    "page2-text13": "费用",
    "page2-text14": "付款",
    "page2-text15": "请确认是否要生成报告？",
    "page3-text1": "创建新客户",
    "page3-text2": "客户信息",
    "page3-text3": "编辑客户",
    "page3-text4": "客户实体详情",
    "page3-text5": "实体名称 (中文)",
    "page3-text6": "实体名称 (英文)",
    "page3-text7": "股票代码",
    "page3-text8": "实体类型",
    "page3-text9": "行业",
    "page3-text9a": "细分行业",
    "page3-text10": "地区",
    "page3-text11": "财政年度结束日",
    "page3-text12": "地址",
    "page3-text13": "联系人姓名",
    "page3-text14": "联系人职位",
    "page3-text15": "联系人邮箱",
    "page3-text16": "香港上市发行人",
    "page3-text17": "私营企业",
    "page3-text18": "非政府组织/法定机构",
    "industry_consumer": "消费品",
    "industry_energy_resources_industrials": "能源、资源与工业",
    "industry_financial_services": "金融服务",
    "industry_government_public_services": "政府与公共服务",
    "industry_life_sciences_health_care": "生命科学与医疗健康",
    "industry_technology_media_telecom": "科技、媒体与电信",
    "sector_automotive": "汽车",
    "sector_consumer_products": "消费品",
    "sector_retail_wholesale_distribution": "零售、批发与分销",
    "sector_transportation_hospitality_services": "交通、酒店与服务",
    "sector_energy_chemicals": "能源与化工",
    "sector_industrial_products_construction": "工业产品与建筑",
    "sector_mining_metals": "采矿与金属",
    "sector_power_utilities_renewables": "电力、公用事业与可再生能源",
    "sector_banking_capital_markets": "银行与资本市场",
    "sector_insurance": "保险",
    "sector_investment_management": "投资管理",
    "sector_real_estate": "房地产",
    "sector_central_government": "中央政府",
    "sector_defense_security_justice": "国防、安全与司法",
    "sector_health_human_services": "卫生与社会服务",
    "sector_infrastructure_transport_regional_government": "基建、交通与地方政府",
    "sector_health_care": "医疗健康",
    "sector_life_sciences": "生命科学",
    "sector_technology": "科技",
    "sector_telecom_media_entertainment": "电信、媒体与娱乐",
    "page3-text24": "客户主要联系人",
    "page3-text25": "项目负责人 (Manager in Charge)",
    "page3-text26": "搜索及添加管理员。如管理员不存在，请先在「安全与访问」中创建。",
    "page3-text27": "按姓名或邮箱搜索",
    "page3-text28": "您不能将自己从项目负责人中移除",
    "page4-text1": "服务方案与范围",
    "page4-text2": "方案",
    "page4-text3": "专业服务费用（港币）",
    "page4-text4": "付款状态",
    "page4-text5": "经理确认：",
    "page4-text6": "本人确认担任经理及以上职级。已通过内部利益冲突核查核实实体信息，及授权创建本项目记录。",
    "page4-text7": "待开票",
    "page4-text8": "已开票",
    "page4-text9": "已付款",
    "page5-text1": "操作指引 (中文)",
    "page5-text2": "操作指引 (英文)",
    "page6-text1": "模块管理",
    "page6-text2": "方案管理",
    "page6-text3": "方案内模块",
    "page6-text4": "最后修改人",
    "page6-text5": "于",
    "page6-text6": "重复方案",
    "page6-text7": "预览",
    "page6-text8": "发布方案",
    "page6-text9": "解绑模块",
    "page6-text10": "全部评估模块",
    "page6-text11": "点击“编辑”以管理题目",
    "page6-text12": "添加模块",
    "page6-text13": "新建模块",
    "page6-text14": "模块总数",
    "page6-text15": "题目总数",
    "page6-text16": "模块名称",
    "page6-text17": "题目",
    "page6-text18": "更新人",
    "page6-text19": "日期",
    "page6-text20": "最新",
    "page6-text21": "发布",
    "page6-text22": "版本",
    "page6-text23": "题目",
    "page6-text24": "确认提示",
    "page6-text25": "请确认是否要添加此模块？",
    "page6-text26": "请确认是否要发布此服务方案？",
    "page6-text27": "请确认是否要解绑此模块？",
    "page7-text1": "创建新模块",
    "page7-text2": "项目信息",
    "page7-text3": "编辑项目",
    "page7-text4": "新版本",
    "page7-text5": "模块版本",
    "page7-text6": "模块名称 (中文)",
    "page7-text7": "模块名称 (英文)",
    "page7-text8": "描述 (中文)",
    "page7-text9": "描述 (英文)",
    "page7-text10": "类型",
    "page7-text11": "是否为董事",
    "page7-text12": "预计用时",
    "page7-text13": "分钟",
    "page7-text14": "不适用",
    "page7-text15": "委员会",
    "page7-text16": "利益相关者",
    "page7-text17": "360度评估",
    "page7-text18": "全部",
    "page7-text19": "董事",
    "page7-text20": "非董事",
    "page8-text1": "发布模块",
    "page8-text2": "点击“编辑”以管理题目",
    "page8-text3": "搜索",
    "page9-text1": "图标",
    "page10-text1": "创建新服务方案",
    "page10-text2": "方案信息",
    "page10-text3": "编辑服务方案",
    "page10-text4": "新版本",
    "page10-text5": "方案版本",
    "page10-text6": "方案名称 (中文)",
    "page10-text7": "方案名称 (英文)",
    "page10-text8": "描述 (中文)",
    "page10-text9": "描述 (英文)",
    "page10-text10": "专业服务费用（港币）",
    "page10-text14": "CG披露模板",
    "page10-text11": "订单编号",
    "page10-text12": "文件强化审核",
    "page10-text13": "启用",
    "page11-text1": "服务方案管理",
    "page11-text2": "新建服务方案",
    "page11-text3": "全部",
    "page11-text4": "待审批",
    "page11-text5": "有效",
    "page11-text6": "已过期/已归档",
    "page11-text7": "方案名称",
    "page11-text8": "描述",
    "page11-text9": "创建人",
    "page11-text10": "创建时间",
    "page11-text11": "状态",
    "page11-text12": "最新",
    "page11-text13": "发布",
    "page11-text14": "版本",
    "page11-text15": "模块",
    "page11-text16": "序号",
    "page12-text1": "请选择...",
    "page13-text1": "版本",
    "page13-text2": "问题类型",
    "page13-text3": "问题标题 (中文)",
    "page13-text4": "问题标题 (英文)",
    "page13-text4a": "题号",
    "page13-text4b": "例如 BEE-A-01",
    "page13-text5": "简短标题 (中文)",
    "page13-text6": "简短标题 (英文)",
    "page13-text7": "参考编号 (中文)",
    "page13-text8": "参考编号 (英文)",
    "page13-text9": "类型",
    "page13-text11": "是否可评论",
    "page13-text12": "标签 (中文)",
    "page13-text13": "标签 (英文)",
    "page13-text14": "权重百分比",
    "page13-text15": "排序号",
    "page13-text16": "单选",
    "page13-text17": "多选",
    "page13-text18": "文本",
    "page13-text19": "董事会有效性评估 (BEE)",
    "page13-text20": "评分",
    "page14-text1": "题目管理",
    "page14-text2": "最后修改人",
    "page14-text3": "于",
    "page14-text4": "重复模块",
    "page14-text5": "发布题目",
    "page14-text6": "解绑题目",
    "page14-text7": "全部评估题目",
    "page14-text8": "点击“编辑”以管理题目",
    "page14-text9": "新题目",
    "page14-text10": "添加题目",
    "page14-text11": "创建新客户",
    "page14-text12": "客户信息",
    "page14-text13": "编辑客户",
    "page14-text14": "分类",
    "page14-text15": "题目内容",
    "page14-text16": "最新版本",
    "page14-text17": "版本",
    "page14-text18": "预览",
    "page14-text19": "请确认是否要保存及发布此方案？",
    "page14-text20": "请确认是否要发布此模块？",
    "page14-text21": "请确认是否要解绑此模块？",
    "page15-text1": "点击“编辑”以管理题目",
    "page15-text2": "新题目",
    "page16-text1": "用户管理",
    "page16-text2": "管理所有项目的内外部用户访问权限",
    "page16-text3": "添加用户",
    "page16-text4": "全部用户",
    "page16-text5": "内部用户",
    "page16-text6": "外部用户",
    "page16-text7": "待处理",
    "page16-text8": "已停用",
    "page16-text9": "添加新用户",
    "page16-text10": "编辑用户",
    "page16-text11": "用户信息",
    "page16-text12": "昵称",
    "page16-text13": "用户名",
    "page16-text14": "邮箱",
    "page16-text15": "职位",
    "page16-text16": "任期 (始于)",
    "page16-text17": "角色",
    "page16-text18": "公司",
    "page16-text19": "年龄段",
    "page16-text20": "重置密码",
    "page16-text21": "用户",
    "page16-text22": "角色与级别",
    "page16-text23": "机构",
    "page16-text24": "状态",
    "page16-text25": "项目",
    "page16-text26": "最后活跃时间",
    "page16-text27": "女",
    "page16-text28": "男",
    "page16-text29": "该邮箱已存在，无法添加新用户，请使用其他邮箱。",
    "page17-text1": "客户信息",
    "page17-text2": "项目合伙人",
    "page17-text3": "邮箱(已保护)",
    "page17-text4": "项目经理",
    "page17-text5": "公司秘书",
    "page17-text6": "客户关键联系人",
    "page17-text7": "项目历史",
    "page17-text8": "财政年度",
    "page17-text9": "状态与报告",
    "page17-text10": "服务方案",
    "page17-text11": "订阅",
    "page17-text12": "专业服务费用",
    "page17-text13": "港币",
    "page17-text14": "付款",
    "page17-text15": "开启",
    "page17-text16": "查看归档",
    "page17-text17": "撤回",
    "page17-text18": "请确认是否要撤回此数据？",
    "page17-text19": "已付款",
    "page17-text20": "未付款",
    "page18-text1": "评估设置",
    "page18-text2": "状态概览",
    "page18-text3": "文件强化审核",
    "page18-text4": "评估仪表板",
    "page18-text5": "行动计划跟踪",
    "page18-text6": "报告与资料库",
    "page18-text7": "本期",
    "page18-text8": "上期",
    "page18-text9": "新增行动项",
    "page18-text10": "领域...",
    "page18-text11": "相关题目 (例如 BEE-F-02)",
    "page18-text12": "负责人 *",
    "page18-text13": "观察项标题",
    "page18-text14": "观察项简称...",
    "page18-text15": "观察项详情",
    "page18-text16": "请详细描述观察到的事实、发现或问题...",
    "page18-text17": "行动计划标题",
    "page18-text18": "简短的行动方案名称...",
    "page18-text19": "行动计划详情",
    "page18-text20": "请详细描述建议的行动方案、具体执行步骤及预期成果...",
    "page18-text21": "目标完成日期",
    "page18-text22": "状态",
    "page18-text23": "保存行动项",
    "page18-text24": "总计",
    "page18-text25": "已完成",
    "page18-text26": "进行中",
    "page18-text27": "存在风险",
    "page18-text28": "编号",
    "page18-text29": "领域",
    "page18-text30": "参考",
    "page18-text31": "观察项标题",
    "page18-text32": "观察内容",
    "page18-text33": "行动项标题",
    "page18-text34": "行动内容",
    "page18-text35": "负责人",
    "page18-text36": "目标",
    "page18-text37": "未开始",
    "page18-text38": "进行中",
    "page18-text39": "已完成",
    "page18-text40": "存在风险",
    "page18-text41": "模块",
    "page18-text42": "已提供：",
    "page18-text43": "分",
    "page18-text44": "部分提供：",
    "page18-text45": "未提供：",
    "page18-text46": "共",
    "page18-text47": "确认最终得分",
    "page18-text48": "已提供",
    "page18-text49": "证据库",
    "page18-text50": "审核人评分",
    "page18-text51": "已提供",
    "page18-text52": "部分提供",
    "page18-text53": "未提供",
    "page18-text54": "评论",
    "page18-text55": "评审员备注...",
    "page18-text56": "是否发现观察项/异常？",
    "page18-text57": "如存在不符合香港交易所 (HKEX) 规定的差距，请进行标记。",
    "page18-text58": "差异记录",
    "page18-text59": "差异总数：",
    "page18-text60": "差异参考编号",
    "page18-text61": "差异标题",
    "page18-text62": "问题简要概述",
    "page18-text63": "描述",
    "page18-text64": "详细描述...",
    "page18-text65": "添加",
    "page18-text66": "得分已确认",
    "page18-text67": "港交所文件强化审核",
    "page18-text68": "全面董事会治理评估，覆盖港交所企业管治守则合规及最佳实践8大领域。",
    "page18-text69": "模块",
    "page18-text70": "监管背景",
    "page18-text71": "建议审核文件",
    "page18-text72": "审核重点",
    "page18-text73": "文件与差异分析",
    "page18-text74": "证据库",
    "page18-text75": "已审核文件：",
    "page18-text76": "否",
    "page18-text77": "是",
    "page18-text78": "点击上传",
    "page18-text79": "或拖拽文件至此",
    "page18-text80": "最大",
    "page18-text81": "确认移除",
    "page18-text82": "当前最多仅可选择3个文件，本次已选择",
    "page18-text83": "个文件",
    "page18-text84": "仅可上传10MB以下文件",
    "page18-text85": "上传成功！",
    "page18-text86": "文件名重复！",
    "page18-text87": "战略成果",
    "page18-text88": "企业管治报告披露草稿",
    "page18-text89": "段落式企业管治报告。",
    "page18-text90": "下载",
    "page18-text91": "绩效仪表板",
    "page18-text92": "得分、成熟度、匹配度。",
    "page18-text93": "行动计划登记册",
    "page18-text94": "带状态的调查结果。",
    "page18-text95": "技能矩阵",
    "page18-text96": "技能与战略匹配。",
    "page18-text97": "战略成果",
    "page18-text98": "审计追踪源数据。",
    "page18-text99": "9 位董事 · 全面披露",
    "page18-text100": "全部模块 · 董事会效能/董事会自评/利益相关方/360度/委员会",
    "page18-text101": "下载报告",
    "page18-text102": "第一部分 — 执行摘要",
    "page18-text103": "本评估报告详细列出了董事会绩效评估的发现，用以支持独立提供的《企业管治披露说明》。报告仅供董事会内部使用。",
    "page18-text104": "百分位",
    "page18-text105": "在德勤董视通同行中",
    "page18-text106": "成熟度评级",
    "page18-text107": "行业领先",
    "page18-text108": "董事会工作重点",
    "page18-text109": "保持及对标",
    "page18-text110": "维持标准、在各委员会间分享最佳实践，及根据监管要求变化定期重新评估。",
    "page18-text111": "优秀",
    "page18-text112": "优化与深化",
    "page18-text113": "维持标准、在各委员会间分享最佳实践，及根据监管要求变化定期重新评估。",
    "page18-text114": "运作有效",
    "page18-text115": "建设与提升",
    "page18-text116": "发挥既有优势开展针对性提升，重点聚焦提升潜力最大的领域。",
    "page18-text117": "逐步完善",
    "page18-text118": "结构化整改与补强",
    "page18-text119": "制定有明确时限的整改计划，落实责任归属、明确交付成果，及定期向董事会汇报。",
    "page18-text120": "预警观察",
    "page18-text121": "升级处理与干预",
    "page18-text122": "启动董事会层面复核，引入独立顾问支持，及实施全面的整改计划。",
    "page18-text123": "每个等级对应特定治理水平解读及下一年度董事会工作重点：",
    "page18-text124": "等级",
    "page18-text125": "分值区间",
    "page18-text126": "定义",
    "page18-text127": "董事会首要任务",
    "page18-text128": "结论与建议后续步骤",
    "page18-text128a": "AI 生成",
    "page18-text128b": "恢复默认",
    "page18-text128c": "根据评审结果使用 AI 生成结论？编辑器中的当前结论将被替换。生成后请检查及保存。",
    "page18-text128d": "将结论恢复为原始评级模板内容？编辑器中的当前结论将被替换。恢复后请检查及保存。",
    "page18-text128e": "AI 结论已生成，请检查及保存。",
    "page18-text128f": "结论已恢复为默认模板，请检查及保存。",
    "page18-text128g": "给 AI 的指引",
    "page18-text129": "领先水平 (LEADING)",
    "page18-text130": "管治实践已深入贯彻、记录详实，及在结构合规性与行为有效性上均高度契合董事会及利益相关者的预期。",
    "page18-text131": "优秀 (STRONG)",
    "page18-text132": "管治实践体系健全，多数评估领域均保持高标准运作，及体现清晰的问责文化与主动监督。",
    "page18-text133": "有效 (EFFECTIVE)",
    "page18-text134": "管治结构与流程基本到位，运行符合核心监管预期，及体现对透明度与董事会层面参与的明确承诺。",
    "page18-text135": "发展中 (DEVELOPING)",
    "page18-text136": "管治流程仅部分实施或应用缺乏连续性，相对监管预期及公认的董事会效能标准存在可觉察的明显短处。",
    "page18-text137": "关注清单 (WATCHLIST)",
    "page18-text138": "在多个维度上存在根本性缺陷，管治实践实质性低于监管预期及公认的董事会效能标准。",
    "page18-text139": "董事会结构与技能矩阵",
    "page18-text140": "企业文化与互动动态",
    "page18-text141": "董事会运作规范",
    "page18-text142": "信息质量与及时性",
    "page18-text143": "董事会会议",
    "page18-text144": "合规与培训",
    "page18-text145": "风险管理与内控",
    "page18-text146": "利益相关方沟通",
    "page18-text147": "确认提交报告？",
    "page18-text148": "第二部分 — 得分构成",
    "page18-text149": "董视通涵盖以下评估模块。最终整体得分由各个已完成模块的加权贡献计算得出。未购买的模块所对应的分值不计入最高总得分上限中。",
    "page18-text150": "模块",
    "page18-text151": "得分",
    "page18-text152": "上期得分",
    "page18-text153": "差异百分比",
    "page18-text342": "贡献得分",
    "page18-text154": "第三部分 — 模块得分卡",
    "page18-text155": "3.1 董事会效能与董事会自评得分卡",
    "page18-text156": "下表列明8大评估领域各自得分，对比基于证据的董事会效能得分与董事会自评得分、二者差异及匹配度评级。",
    "page18-text157": "领域",
    "page18-text158": "董事会效能",
    "page18-text159": "董事会自评",
    "page18-text160": "匹配度",
    "page18-text161": "匹配度说明",
    "page18-text162": "匹配",
    "page18-text163": "自评结果有充分证据支持。",
    "page18-text164": "中等差异",
    "page18-text165": "值得重新核对和审阅底稿文件记录。",
    "page18-text166": "实质性偏差",
    "page18-text167": "需进一步调查引发偏差的深层原因。",
    "page18-text343": "匹配 (<15%)",
    "page18-text344": "中等差异 (15%–<30%)",
    "page18-text345": "实质性偏差 (≥30%)",
    "page18-text168": "说明与计算公式",
    "page18-text169": "差异百分比",
    "page18-text170": "= (董事会效能 − 董事会自评) ÷ 二者最大值 × 100",
    "page18-text171": "= 本期 − 上期",
    "page18-text172": "3.2 利益相关方模块",
    "page18-text173": "利益相关者模块收集了三个受访者群体的匿名反馈。具体的受访人数及李克特量表平均得分 (1–5分) 如下表所示。",
    "page18-text174": "群体",
    "page18-text175": "参与人数",
    "page18-text176": "平均分（1–5）",
    "page18-text177": "上期得分",
    "page18-text178": "较上年变化",
    "page18-text179": "3.3 董事360度评估",
    "page18-text180": "董事 360° 模块采用匿名同行互评机制。单独个人的董事评分属于严格保密信息，不会在本报告中披露。",
    "page18-text181": "3.4 委员会评估",
    "page18-text182": "各活跃的董事会专门委员会均通过一套通用的 12 道题评估框架进行了评审。各专门委员会层面的平均得分如下所述。",
    "page18-text183": "委员会",
    "page18-text184": "3.5 文件强化审核",
    "page18-text185": "文件强化审核由德勤独立开展，8大评估领域根据支持文件完整性与质量评为已提供、部分提供或未提供。",
    "page18-text186": "评级定义",
    "page18-text187": "已提供（1.25分）",
    "page18-text188": " — 企业针对该维度提供了完备、结构正式且内部逻辑一致的文件底稿。这些文件具有独立支撑力：其他评审人员依凭同样的文件，无需口头澄清或补充往来函件，便能得出完全相同的 BEE 得分结论。",
    "page18-text189": "部分提供（0.625分）",
    "page18-text190": "— 企业针对该维度提供了材料，但整体文件不完整、结构较不正式，或在很大程度上依赖补充性材料背景（如邮件往来链、口头确认或访谈记录）来佐证特定的 BEE 得分。书面文本表面呈现的情况与最终得分之间存在明显差距。",
    "page18-text191": "未提供（0分）",
    "page18-text192": "— 企业未提供该维度的相关材料，或者提供的书面文件存在实质性严重缺陷，导致无法对 BEE 得分进行实质有效的书面审阅校验。该维度不给予任何强化审阅分值。",
    "page18-text193": "状态",
    "page18-text194": "已提供",
    "page18-text195": "部分提供",
    "page18-text196": "未提供",
    "page18-text197": "第四部分 — 重点题目",
    "page18-text198": "本章节列出了所有已完成模块中得分最高和得分最低的题目，从个题视点宏观展现管治优势与值得关注的问题区域。",
    "page18-text199": "4.1 高分项区域（≥ 4.25分）",
    "page18-text200": "这些代表了在本次评估周期内董事会公司管治实践中表现最强健的领域。",
    "page18-text201": "4.2 需关注领域（≤1.5分）",
    "page18-text202": "为最高优先级改进事项，对应实践缺失或存在明确缺陷的问题。",
    "page18-text203": "领域/群体",
    "page18-text204": "名称",
    "page18-text204a": "参考",
    "page18-text205": "第五部分 — 开放式文本回复",
    "page18-text206": "摘自董事会自评与利益相关方模块的全部开放式回复，已匿名处理且无个人归属，全文展示，未做概括或主题归类。",
    "page18-text207": " — 评估报告",
    "page18-text208": " · ",
    "page18-text209": ".HK",
    "page18-text210": "服务方案：",
    "page18-text211": "评估：",
    "page18-text212": "报告：",
    "page18-text213": "机密 — 仅供董事会使用。本报告支持另行提供的企业管治披露，不得对外公开。",
    "disclaimerReviewDashboard": "<p>本公司于评估期内开展了正式的董事会绩效评估。评估以自评及／或互评形式进行，由本公司内部自行实施，及通过本所提供的数字化平台完成。</p><p>本所的角色仅限于提供评估平台，及不包括核实、审计或独立评估所提交答复的准确性、完整性或可靠性。本次评估结果不构成审计、鉴证业务，亦不构成对董事会绩效的独立评估，任何第三方均不应据此依赖。</p><p>评估结果的可靠性本质上取决于答复人员的坦诚、勤勉与诚信。由于评估基于个人观感与主观判断，相关结果应据此理解与解读。评估发现仅供本公司内部管治改进之用。</p>",
    "disclaimerQuestionnaire": "免责声明",
    "page18-text214": "董事",
    "page18-text215": "是否牵头",
    "page18-text216": "职位",
    "page18-text217": "昵称",
    "page18-text218": "用户名",
    "page18-text219": "邮箱",
    "page18-text220": "职务",
    "page18-text221": "角色",
    "page18-text222": "性别",
    "page18-text223": "年龄",
    "page18-text224": "任期（始于）",
    "page18-text225": "是",
    "page18-text226": "否",
    "page18-text227": "女",
    "page18-text228": "男",
    "page18-text229": "参与人员与模块分配",
    "page18-text230": "添加参与人员",
    "page18-text231": "董事",
    "page18-text232": "位参与人员已加载",
    "page18-text233": "姓名",
    "page18-text234": "类别",
    "page18-text235": "职务",
    "page18-text236": "性别",
    "page18-text237": "年龄",
    "page18-text238": "任期（始于）",
    "page18-text239": "非董事参与人员",
    "page18-text240": "类别",
    "page18-text241": "邮箱",
    "page18-text242": "确认分配",
    "page18-text243": "请选择模块！",
    "page18-text244": "设置进度",
    "page18-text245": "就绪",
    "page18-text246": "保存草稿",
    "page18-text247": "启动评估",
    "page18-text248": "需要指引？",
    "page18-text249": "有关模块配置或技术问题，请参阅标准作业程序或联系咨询台。",
    "page18-text250": "查看标准操作文档",
    "page18-text251": "联系支持团队",
    "availableSoon": "即将推出",
    "page18-text252": "参与人员与角色",
    "page18-text253": "日程与邮件",
    "page18-text254": "描述与提示",
    "page18-text255": "描述",
    "page18-text256": "恢复默认",
    "page18-text257": "提示",
    "page18-text258": "恢复默认值",
    "page18-text259": "日程与分发",
    "page18-text260": "启动日期",
    "page18-text261": "截止日期",
    "page18-text262": "自动提醒",
    "page18-text263": "项目启动时",
    "page18-text264": "中期",
    "page18-text265": "截止前3天",
    "page18-text266": "邀请邮件预览",
    "page18-text267": "插入数据",
    "page18-text268": "恢复默认",
    "page18-text269": "标题",
    "page18-text270": "预览並发送测试",
    "page18-text271": "确认日程",
    "page18-text272": "请完成填写！",
    "page18-text273": "服务包与模块配置",
    "page18-text274": "备注：",
    "page18-text275": "这些模块是根据您与德勤签署的项目业务约定书 (Engagement Letter) 进行自动指派的。如果您认为存在不符之处，请在确认提交前联系您的德勤服务项目组。",
    "page18-text276": "已选方案",
    "page18-text277": "包含模块",
    "page18-text278": "参与人员",
    "page18-text279": "状态",
    "page18-text280": "进度概览",
    "page18-text281": "实时完成状态。",
    "page18-text282": "按模块",
    "page18-text283": "按参与人员",
    "page18-text284": "参与人员",
    "page18-text285": "整体状态",
    "page18-text286": "模块明细（1-8）",
    "page18-text287": "最近审计操作记录",
    "page18-text288": "时间",
    "page18-text289": "用户",
    "page18-text290": "角色",
    "page18-text291": "执行动作",
    "page18-text292": "详情",
    "page18-text293": "订阅模块总数。",
    "page18-text294": "日",
    "page18-text294-singular": "日",
    "page18-text295": "开始：",
    "page18-text296": "结束：",
    "page18-text297": "模块总数",
    "page18-text298": "订阅模块总数。",
    "page18-text299": "参与人员",
    "page18-text300": "独立参与人数。",
    "page18-text301": "问卷回复率",
    "page18-text302": "提交总数 / 请求总数。",
    "page18-text303": "确认文件上传",
    "page18-text304": "您确认所有需审阅的文件都已上传完毕？",
    "page18-text305": "跳过上传",
    "page18-text306": "不跳过上传",
    "page18-text307": "剩余时间",
    "page18-text308": "合计",
    "page18-text309": "输入数据",
    "page18-text310": "管理控制",
    "page18-text311": "管理此评估的整个生命周期。",
    "page18-text312": "发送提醒",
    "page18-text313": "延长截止日期",
    "page18-text314": "结束评估",
    "page18-text314a": "重新开启评估",
    "page18-text314b": "问卷进行中",
    "page18-text314c": "问卷已关闭",
    "page18-text315": "请确认是否要发送提醒？",
    "page18-text316": "请确认是否要结束评估？",
    "page18-text316a": "请确认是否要重新开启评估？",
    "page18-text317": "当前状态不允许上传文件",
    "page18-text318": "暂无已上传文件",
    "page18-text319": "待启动",
    "page18-text320": "评估进行中",
    "page18-text321": "审核中",
    "page18-text322": "待最终审核",
    "page18-text323": "报告已生成",
    "page18-text324": "已完成",
    "page18-text325": "待完成",
    "page18-text326": "公司名称",
    "page18-text327": "问卷链接",
    "page18-text328": "截止日期",
    "page18-text329": "登录邮箱",
    "page18-text329": "未发现高分项区域。",
    "page18-text330": "未发现需关注领域（≤1.5分）。",
    "page18-text331": "请确认是否要启动此评估？",
    "page18-text332": "评估已成功启动。",
    "page18-text333": "提交並完成",
    "page18-text334": "题号",
    "page18-text335": "客户管理员",
    "page18-text336": "添加管理员",
    "page18-text337": "该公司尚未添加客户管理员，请添加客户管理员。",
    "page18-text338": "添加客户管理员",
    "page18-text339": "姓名",
    "page18-text340": "是否删除参与者？",
    "page18-text341": "参与者已删除",
    "fileNotAvailableYet": "文件尚未就绪",
    "page19-text1": "提交截止日期：",
    "page19-text2": "关键信息",
    "page19-text3": "截止日期：",
    "page19-text4": "整体进度",
    "page19-text5": "您的分配模块",
    "page19-text6": "未开始",
    "page19-text7": "已开始",
    "page19-text8": "已完成",
    "page19-text9": "分钟",
    "page19-text10": "开始",
    "page19-text11": "查看",
    "page19-text12": "已提交",
    "page19-text13": "未提交",
    "page20-text1": "项目管理",
    "page20-text2": "公司",
    "page20-text3": "财政年度",
    "page20-text4": "服务方案",
    "page20-text5": "打开",
    "page20-text6": "查看",
    "page20-text7": "状态",
    "page20-text8": "待开启",
    "page20-text9": "进行中",
    "page20-text10": "已关闭",
    "page21-text1": "问题",
    "page21-text2": "已完成：",
    "page21-text3": "返回首页",
    "page21-text4": "状态",
    "page21-text5": "未开始",
    "page21-text6": "进行中",
    "page21-text7": "已完成",
    "page21-text8": "预计用时",
    "page21-text9": "分钟",
    "page21-text10": "进度",
    "page21-text11": "自动保存",
    "page21-text12": "已保存",
    "page21-text13": "选择委员会",
    "page21-text14": "选择您的受访群体",
    "page21-text15": "选择需评估的董事",
    "page21-text16": "继续",
    "page21-text17": "请完成表格",
    "page21-text18": "请完成所有模块",
    "page21-text18a": "请完成：{modules}",
    "page21-text19": "参考：",
    "page21-text20": "添加评论",
    "page21-text21": "请确认提交问卷？提交后将无法再修改答案。",
    "engagement_management_text1": "客户信息"
};
